import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css"; // Import these styles for slick carousel
import UrltoSlug from './common/UrlToSlug';
import { useNavigate } from 'react-router-dom';

// Custom Previous Arrow Component
const PrevArrow = ({ onClick }) => (
  <button className="custom-btn custom-btn-prev" onClick={onClick}>
    &lt;
  </button>
);

// Custom Next Arrow Component
const NextArrow = ({ onClick }) => (
  <button className="custom-btn custom-btn-next" onClick={onClick}>
    &gt;
  </button>
);

const AdvertisementLocality = ({ popularLocalities }) => {

  // Slick carousel settings
  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };
 const navigate = useNavigate();
  const handleLinkClick = (project) => {
    //alert(JSON.stringify(project))
     const text1 = `/buy/searches`;
        const text2 = `${project?.property_location}-srlid-${project?.id}`;
        const extra = 'apartments-for-sale-in-'
        const url = `${text1}/${extra ?? 'property-in-'}${UrltoSlug(text2)}`
       localStorage.setItem('feature_clicked', `property_type:apartment`);
    // let url = '';
    // url = `/buy/searches/srlid-${project.id}`;
    window.location.href = url;
    //  navigate(
    //         `/${url}`,
    //        { state: {filter : filter} }
    //       );
  }


  return (
    <>
      {popularLocalities?.length > 0 && (
        <div className="popular_locality desk mt-4">
          <p>Popular Locality for sale</p>
          <div className="titleunderline">
            <svg width="71" height="7" viewBox="0 0 71 7" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.113249 3.5L3 6.38675L5.88675 3.5L3 0.613249L0.113249 3.5ZM70.8867 3.5L68 0.613249L65.1132 3.5L68 6.38675L70.8867 3.5ZM3 4H68V3H3V4Z" fill="#002842" />
              <line x1="8.5" y1="6.5" x2="62.5" y2="6.5" stroke="#002842" stroke-linecap="round" />
            </svg>
          </div>

          {/* Custom Slick Carousel */}
          <div className="custom-carousel">
            <Slider {...settings}>
              {popularLocalities?.length > 0 && (
                popularLocalities?.reduce((result, project, index) => {
                  if (index % 2 === 0) {
                    result.push([]);
                  }
                  result[result.length - 1].push(project);
                  return result;
                }, []).map((group, i) => (
                  <div className={`carousel-item ${i === 0 ? 'active' : ''}`} key={i}>
                    <div className="row" style={{ margin: 0 }}>
                      {group.map((project, index) => (
                        <div className="col-md-6 mb-4" key={index}>
                          <div className="unique-card">
                            <h5>{project?.name}</h5>
                            <div className="pricing_det">
                              <p className="price">₹ {parseInt(project?.avg_price)}</p>
                              <p className="details">Avg. Price Per Sq.Ft</p>
                            </div>
                            <div className="price_grap">
                              <p className="price">
                                {project?.price_increased}%
                                {project?.price_increased >= 0 ? " ▲" : " ▼"}
                              </p>
                              <p className="details">Rise In Last 1 Year</p>
                            </div>
                            <Link onClick={() => handleLinkClick(project)}>
                              <button className="btn view-projects-btn">View Projects</button>
                            </Link>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </Slider>
          </div>
        </div>
      )}
    </>
  );
};

export default AdvertisementLocality;
